import { Slider as SliderComponent } from 'components/slider'
import Slide1 from './assets/01.webp'
import Slide2 from './assets/02.webp'
import Slide3 from './assets/03.webp'
import Slide4 from './assets/04.webp'
import Slide5 from './assets/05.webp'
import Slide6 from './assets/06.webp'

export const Slider = () => (
  <SliderComponent
    maximumWidth={542}
    imagesPerView={3}
    aspectRatio="542 / 845"
    overlayOnlyOnHover
    slides={[
      {
        src: Slide1,
        title: 'Пугало',
        description: '2020, реж. Дмитрий Давыдов',
        link: 'https://www.youtube.com/watch?v=9lz_7bsNxZI',
        overlayText: 'Смотреть трейлер',
      },
      {
        src: Slide2,
        title: 'Иччи',
        description: '2020, реж. Костас Марсаан',
        link: 'https://www.youtube.com/watch?v=KI98jxgg6bY',
        overlayText: 'Смотреть трейлер',
      },
      {
        src: Slide3,
        title: 'Не хороните меня без Ивана',
        description: '2022, реж. Любовь Борисова',
        link: 'https://www.youtube.com/watch?v=_b4Qn9uNQ4o',
        overlayText: 'Смотреть трейлер',
      },
      {
        src: Slide4,
        title: 'Его дочь',
        description: '2016, реж. Татьяна Эверстова',
        link: 'https://www.kinopoisk.ru/film/994627/video/143059/',
        overlayText: 'Смотреть трейлер',
      },
      {
        src: Slide5,
        title: 'Айта',
        description: '2022, реж. Степан Бурнашев',
        link: 'https://youtu.be/g0XQpGtsowY?si=puTxYFItLiae6_s7',
        overlayText: 'Смотреть трейлер',
      },
      {
        src: Slide6,
        title: 'Айыы Куо',
        description: '2022, реж. Айаал Адамов',
        link: 'https://www.youtube.com/watch?v=SorKXo_DefE',
        overlayText: 'Смотреть трейлер',
      },
    ]}
  />
)
